define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var DocumentCategoryModel = /** @class */ (function () {
        function DocumentCategoryModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Type = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, DocumentCategoryModel.Mapping, self);
            }
        }
        DocumentCategoryModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new DocumentCategoryModel(options.data);
            }
        };
        return DocumentCategoryModel;
    }());
    return DocumentCategoryModel;
});
//# sourceMappingURL=DocumentCategoryModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/DocumentCategoryModel.js
// module id = 281
// module chunks = 2